export function autosuggestions() {
	const suggestionsElements = document.querySelectorAll(".js-auto-suggestions");
	const htmlElement = document.querySelector("html");
	if (suggestionsElements.length) {
		const testSuggestions = [
			"Apple",
			"Banana",
			"Cherry",
			"Date",
			"Elderberry",
			"Fig",
			"Grape",
		];
		const useTestData = false; // Set to `true` in the test environment, always set to false before committing

		suggestionsElements.forEach((suggestionsElement) => {
			suggestionsElement.addEventListener("input", () => {
				const inputValue = suggestionsElement.value;
				if (inputValue.length > 1) {
					if (useTestData) {
						// Use the test array instead of fetching from the API
						const suggestionsMarkup = generateSuggestionsMarkup(
							testSuggestions,
							inputValue,
						);
						addSuggestionsMarkup(suggestionsElement, suggestionsMarkup);
					} else {
						const pageId =
							suggestionsElement.getAttribute("data-search-pageid");
						const useraffle = suggestionsElement.getAttribute("data-useraffle");
						const lang = htmlElement.getAttribute("lang");
						// Define the API URL
						const apiUrl =
							"/api/search/GetTypeAhead?searchTerm=" +
							inputValue +
							"&pageId=" +
							pageId +
							"&lang=" +
							lang +
							"&useRaffle=" +
							useraffle;
						fetch(apiUrl, {
							method: "GET",
							headers: {
								"Content-Type": "application/json",
							},
						})
							.then((response) => response.json())
							.then((data) => {
								// Handle the response data
								if (Array.isArray(data)) {
									if (data.length) {
										const suggestionsMarkup = generateSuggestionsMarkup(
											data,
											inputValue,
										);
										addSuggestionsMarkup(suggestionsElement, suggestionsMarkup);
									} else {
										removeSuggestions(suggestionsElement);
									}
								} else {
									removeSuggestions(suggestionsElement);
								}
							})
							.catch((error) => {
								// Handle any errors
								console.error("Error:", error);
							});
					}
				}
				if (inputValue.length == 0) {
					removeSuggestions(suggestionsElement);
				}
			});

			suggestionsElement.addEventListener("click", (event) => {
				event.preventDefault();
			});
			// Add focus event to show top questions when input is focused
			suggestionsElement.addEventListener("focus", () => {
				if (suggestionsElement.value.length === 0) {
					AddTopSuggestions(suggestionsElement);
				}
			});

			// UNFOCUS EVENT NOT ON .suggestions--autocomplete
			suggestionsElement.addEventListener("blur", () => {
				// Forsinket fjernelse for at give tid til klik på forslag
				setTimeout(() => {
					removeSuggestions(suggestionsElement);
				}, 200);
			});

			suggestionsElement.addEventListener("keydown", (event) => {
				const closestForm = suggestionsElement.closest("form");
				const suggestionsContainer = closestForm.querySelector(
					".suggestions--autocomplete ul",
				);
				if (suggestionsContainer) {
					const items = suggestionsContainer.querySelectorAll("li");
					let currentIndex = Array.from(items).findIndex((item) =>
						item.classList.contains("highlighted"),
					);
					if (event.key === "ArrowDown") {
						event.preventDefault();
						if (currentIndex < items.length - 1) {
							currentIndex++;
						} else {
							currentIndex = 0;
						}
						highlightItem(items, currentIndex);
					} else if (event.key === "ArrowUp") {
						event.preventDefault();
						if (currentIndex > 0) {
							currentIndex--;
						} else {
							currentIndex = items.length - 1;
						}
						highlightItem(items, currentIndex);
					} else if (event.key === "Enter") {
						event.preventDefault();
						if (currentIndex > -1) {
							if (items[currentIndex].querySelector("button").dataset.query) {
								suggestionsElement.value =
									items[currentIndex].querySelector("button").dataset.query;
							} else {
								suggestionsElement.value =
									items[currentIndex].querySelector("button").innerText;
							}
							removeSuggestions(suggestionsElement);

							if (closestForm) {
								closestForm.submit();
							}
						} else {
							if (closestForm) {
								closestForm.submit();
							}
						}
					}
				}
			});
		});
	}

	function generateSuggestionsMarkup(suggestions, searchTerm) {
		let markup = '<div class="suggestions--autocomplete active"><ul>';
		const searchTermRegex = new RegExp(`(${searchTerm})`, "gi");
		suggestions.forEach((suggestion) => {
			const highlightedSuggestion = suggestion.replace(
				searchTermRegex,
				"<b>$1</b>",
			);
			markup += `<li><button>${highlightedSuggestion}</button></li>`;
		});
		markup += "</ul></div>";
		return markup;
	}

	function addSuggestionsMarkup(inputElement, markup) {
		const formElement = inputElement.closest("form");
		if (formElement) {
			// Remove existing suggestions if present
			const existingSuggestions = formElement.querySelector(
				".suggestions--autocomplete",
			);
			if (existingSuggestions) {
				existingSuggestions.remove();
			}

			// Insert the new suggestions
			formElement.insertAdjacentHTML("beforeend", markup);

			// Add click event listener to each suggestion
			const suggestionButtons = formElement.querySelectorAll(
				".suggestions--autocomplete button",
			);
			suggestionButtons.forEach((button) => {
				button.addEventListener("click", (event) => {
					event.preventDefault();
					console.log("Clicked suggestion:", button.innerText);
					if (button.dataset.query) {
						inputElement.value = button.dataset.query;
					} else {
						inputElement.value = button.innerText;
					}
					removeSuggestions(inputElement);
					const closestForm = inputElement.closest("form");
					if (closestForm) {
						closestForm.submit();
					}
				});
			});
		}
	}
	function removeSuggestions(inputElement) {
		const formElement = inputElement.closest("form");
		if (formElement) {
			const existingSuggestions = formElement.querySelector(
				".suggestions--autocomplete",
			);
			if (existingSuggestions) {
				existingSuggestions.remove();
			}
		}
	}
	function highlightItem(items, index) {
		items.forEach((item, idx) => {
			if (idx === index) {
				item.classList.add("highlighted");
				item.scrollIntoView({ block: "nearest" });
			} else {
				item.classList.remove("highlighted");
			}
		});
	}

	function generateTopquestionsMarkup(topQuestions) {
		console.log(topQuestions);
		let markup = '<div class="suggestions--autocomplete active">';
		markup += `<h2 class="h5">${topQuestions.title}</h2>`;
		markup += "<ul>";
		topQuestions.questions.forEach((questions) => {
			markup += `<li class="has-icon"><button data-query="${questions.query}"><span class="icon-speech_balloon"></span><span>${questions.text}</span></button></li>`;
		});
		markup += "</ul></div>";
		return markup;
	}
	function AddTopSuggestions(topQuestionElement) {
		const pageId = topQuestionElement.getAttribute("data-search-pageid");
		const useraffle = topQuestionElement.getAttribute("data-useraffle");
		const lang = htmlElement.getAttribute("lang");
		const apiUrl =
			"/api/search/GetTopQuestions?pageId=" +
			pageId +
			"&lang=" +
			lang +
			"&useRaffle=" +
			useraffle;
		fetch(apiUrl, {
			method: "GET",
		})
			.then((response) => response.json())
			.then((data) => {
				if(data.questions.length === 0) {
					return;
				}
				const topQuestionsMarkup = generateTopquestionsMarkup(data);
				addSuggestionsMarkup(topQuestionElement, topQuestionsMarkup);
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}
}

export default autosuggestions;
